<template>
    <div :id="id" class="home-module-chart"></div>
</template>
<script>
// import graph from '@/api/mock/graph.json'
import searchApi from '@/api/search.js'

export default {
    name: 'index',
    data () {
        return {
            id:
                'module-chart-' +
                Math.random()
                    .toString(36)
                    .slice(-8),
            chart: null,
            graph: {}
        };
    },
    props: {
        options: Object
    },
    methods: {
        initChart () {
            searchApi.selectKnowledgeGraph().then(response => {
                if (response.rows.length > 0) {
                    this.graph = JSON.parse(response.rows[0].graphInfos);
                    if (this.graph.nodes.length > 0) {
                        this.$bus.$emit('knowledgeNodeClick', this.graph.nodes[0]);
                    }
                    this.setChart();
                }
            })
        },
        setChart () {
            //   let data = []
            let colors = ['#ffa40f', '#954416', '#773d31', '#5d3131', '#a7535a', '#e3b4b8', '#f9d770', '#f8bc31', '#4d4030', '#daa45a', '#8e804b', '#fa7e23'];
            this.graph.nodes.forEach(item => {
                item.itemStyle = {
                    color: colors[item.category]
                }
            });
            var option = {
                color: colors,
                tooltip: {},
                legend: [
                    {
                        data: this.graph.categories.map(function (a) {
                            return a.name;
                        }),
                        top: 40
                    }
                ],
                series: [
                    {
                        type: 'graph',
                        layout: 'force',
                        data: this.graph.nodes,
                        links: this.graph.links,
                        categories: this.graph.categories,
                        roam: true,
                        label: {
                            show: true,
                            // position: 'center',
                            formatter: function (value) {
                            if (value.name.length > 4) {
                                return value.name.substring(0, 4) + '...';
                            } else {
                                return value.name;
                            }
                            },
                            fontSize: this.$isPhone ? 24 : 14,
                            align: 'center'
                        },
                        force: {
                            repulsion: 100
                            // gravity: 0.2
                        },
                        lineStyle: {
                            color: 'source',
                            curveness: 0.3
                        },
                        tooltip: {
                            trigger: 'item',
                            formatter: function (params) {
                                // 在这里编写自定义的悬浮显示内容
                                // params包含了当前节点的数据和其他信息
                                // 例如：params.name 是节点的名称，params.data 是节点的数据

                                // 返回一个HTML字符串，用于显示悬浮框的内容
                                return '<div style="display: flex; align-items: center;">' +
                                    '<div style="width: 10px; height: 10px; border-radius: 10px; background: ' + colors[params.data.category] + '; margin-right: 8px;"></div>' +
                                    '<p>' + params.name + '</p>' + // 显示节点名称
                                    '</div>';
                            }
                            // 其他Tooltip配置项...
                        }
                    }
                ]
            };
            this.chart.setOption(option);
        }
    },
    mounted () {
        this.chart = this.$echarts.init(document.getElementById(this.id), 'light');
        this.initChart();
        this.chart.on('click', 'series.graph', params => {
            // console.log(params)
            this.$bus.$emit('knowledgeNodeClick', params.data);
        })
        window.addEventListener('resize', () => {
            this.chart.resize();
        });
    }
};
</script>
<style lang="less" scoped>
@import "~@/styles/variables.less";
@import '~@/styles/variables.less';

// @media screen and (min-width: 769px) {
    .home-module-chart {
    margin-top: 70px;
    width: 1622px;
    height: 768px;
}
// }
// @media screen and (max-width: 768px) {
//     .home-module-chart {
//      margin-top: 140px;
//      width: 871px;
//      height: 727px;
//      overflow: hidden;
//    }
// }
</style>
